<script setup lang="ts">
import type { IOrganization } from "~/types";

defineProps<{
  organization?: IOrganization | null;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex items-center gap-2 py-2 px-4 border-b border-neutral-light-300 dark:border-neutral-dark-900 text-sm">
    <span class="text-secondary">{{ t('labels.tenant', 2) }}</span>
    <div class="flex items-center gap-2">
      <UAvatar
        v-if="organization"
        :src="organization?.logo_url"
        :alt="organization?.name"
        :size="20"
      />
      <h2 class="font-medium">{{ organization?.name ?? t("labels.unassigned") }}</h2>
    </div>
  </div>
</template>